import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InsuranceTile from 'src/components/BuyPolicy/insuranceScreens/health/InsuranceTile'
import WalletImg from 'src/assets/Buy_Policy_Images/Wallet.svg'

export const useStyles = makeStyles({
  budgetContainerMain: {
    display: 'flex',
    flexDirection: 'column',
    margin: '20px 0',
  },
  budgetContainer: {
    border: '1px solid #73CFEE',
    borderRadius: '5px 5px 0px 0px',
    background: 'linear-gradient(180deg, #73CFEE 4.08%, #FFFFFF 102.47%)',
    width: 'fit-content',
    marginLeft: '2%',
  },
  insuranceTileContainer: {
    zIndex: 1,
  },

  budgetContainerText: {
    color: '#3A859A',
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '13px',
    letterSpacing: '0.02em',
    padding: 5,
  },
  economicContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 14,
  },
  economicContainerLogo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    borderRadius: '0px 0px 15px 15px',
    background: '#73CFEE',
    width: 'fit-content',
    padding: '5px 40px 5px 40px',
    marginLeft: '2%',
  },
  economicContainerText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '12.89px',
    letterSpacing: '0.02em',
    color: '#FFFFFF',
  },
})

const InsuranceTileBudget = ({ insuranceDetails }) => {
  const classes = useStyles()

  return (
    <div className={classes.budgetContainerMain}>
      <div className={classes.budgetContainer}>
        <span className={classes.budgetContainerText} id='BudgetContainer'>
          BudgetGuard
        </span>
      </div>

      <div className={classes.insuranceTileContainer}>
        <InsuranceTile insuranceDetails={insuranceDetails} />
      </div>

      <div className={classes.economicContainer}>
        <div className={classes.economicContainerLogo}>
          <div>
            <img src={WalletImg} alt='budgetGuard-img' id='WalletIamge'></img>
          </div>

          <div className={classes.economicContainerText} id='EconomicText'>
            Economical Coverage Without Compromise
          </div>
        </div>
      </div>
    </div>
  )
}

export default InsuranceTileBudget
